<template>
  <div class="law-page">
    <section class="banner">
      <div class="b_title">
        <div class="h1">{{ $t('siteFooter.legal') }}</div>
        <div class="h2">LEGAL INFORMATION</div>
      </div>
    </section>

    <section class="bread_bar_wrapper">
      <div class="bread_bar section">
        <div class="left">
          <img class="item icon" src="@/static/image/about6.png" alt="home" />
          <router-link :to="homeLink" class="item active">{{ $t('nav.home') }}</router-link>
          <span class="item">&gt;</span>
          <span class="item">{{ $t('siteFooter.legal') }}</span>
          <span class="item">&gt;</span>
          <span class="item">{{ currentTabLabel }}</span>
        </div>

        <div class="right">
          <a
            href="javascript:void(0)"
            class="item"
            :class="{ active: activeTab === 'service' }"
            @click="switchTab('service')"
          >
            {{ tabs.service.label }}
            <span class="border"></span>
          </a>
          <a
            href="javascript:void(0)"
            class="item"
            :class="{ active: activeTab === 'privacy' }"
            @click="switchTab('privacy')"
          >
            {{ tabs.privacy.label }}
            <span class="border"></span>
          </a>
        </div>
      </div>
    </section>

    <section class="info">
      <div class="section card">
        <div class="content" v-html="currentTab.content"></div>
      </div>
    </section>

    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from '@/components/layout/newHome/sections/SiteFooter.vue'
import { legalInfoTabs } from '@/config/legalInfo'

export default {
  name: 'LegalInfo',
  components: { SiteFooter },
  computed: {
    currentLocale() {
      return (this.$i18n && this.$i18n.locale) || 'zh-CN'
    },
    homeLink() {
      return { path: '/', query: { lang: this.currentLocale } }
    },
    tabs() {
      return legalInfoTabs[this.currentLocale] || legalInfoTabs['zh-CN']
    },
    activeTab() {
      return this.$route.query.tab === 'privacy' ? 'privacy' : 'service'
    },
    currentTab() {
      return this.tabs[this.activeTab] || this.tabs.service
    },
    currentTabLabel() {
      return this.currentTab.label
    }
  },
  methods: {
    switchTab(tab) {
      this.$router.replace({
        path: '/home/legal-info',
        query: {
          ...this.$route.query,
          tab,
          lang: this.currentLocale
        }
      })
    }
  }
}
</script>

<style scoped>
.law-page { background: #f7f8fa; padding-top: 80px; }
.section { width: 1200px; margin: 0 auto; }
.banner { height: 300px; background: url('~@/static/image/contact-banner.png') center center / cover no-repeat; position: relative; }
.banner .b_title { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; }
.banner .h1 { color: #fff; font-size: 50px; line-height: 1.1; }
.banner .h2 { color: #fff; font-size: 30px; margin-top: 14px; letter-spacing: 2px; }
.bread_bar_wrapper { height: 62px; background: #fff; border-bottom: 1px solid #eef1f5; }
.bread_bar { display: flex; justify-content: space-between; align-items: center; height: 100%; }
.bread_bar .left { display: flex; align-items: center; font-size: 14px; }
.bread_bar .left .icon { width: 17px; margin-right: 10px; }
.bread_bar .left .item { margin-right: 8px; color: #333; text-decoration: none; }
.bread_bar .right { display: flex; height: 100%; align-items: center; }
.bread_bar .right .item { width: 110px; text-align: center; color: #4a5568; text-decoration: none; position: relative; }
.bread_bar .right .item .border { position: absolute; bottom: -22px; left: 50%; transform: translateX(-50%); width: 0; height: 3px; background: #1c51a3; transition: width 0.25s; }
.bread_bar .right .item.active { color: #1c51a3; }
.bread_bar .right .item.active .border { width: 92px; }
.info { padding: 28px 0 50px; }
.card { background: #fff; border-radius: 10px; box-shadow: 0 10px 24px rgba(26, 57, 110, 0.06); padding: 28px 30px; }
.content { line-height: 1.9; color: #333; font-size: 15px; text-align: left; }
.content :deep(.PrivacyBox .title1),
.content :deep(.PrivacyBox h2) {
  text-align: center;
}
</style>
